import React from 'react'
import PropTypes from 'prop-types'
import { Map } from 'immutable'
import classNames from 'classnames'
import { PureDataComponent } from '@aytm/lib/common/components/pure-component'

import '@aytm/lib/rfd-ui/styles/basic/select.scss'
import '@aytm/lib/rfd-ui/styles/basic/label.scss'

export default class Label extends PureDataComponent {
  static propTypes = {
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    placeholder: PropTypes.string,
    icon: PropTypes.string,
    iconRight: PropTypes.bool,
    withArrow: PropTypes.bool,
    onClick: PropTypes.func
  }

  constructor(props) {
    super(props)
    this.state = {
      opened: false,
      valueOption: Map({ value: null, text: '' }),
      filter: '',
      keyboardIndex: null,
      focused: false,
      flipped: false,
      page: 1
    }
    this.filterChangeDelayTimer = null
    this.mounted = false
    this.mouseOverOptions = false
    this.filteredOptionsCache = null
    this.filteredOptionsCacheFor = null
    this.selectRoot = null
    this.options = null
    this.overflow = 0
    this.loading = false
  }

  render() {
    const { width, placeholder, onClick, icon, iconRight, withArrow, className, ...otherProps } = this.props

    return (
      <div
        className={classNames('rfd-ui-select', 'rfd-ui-label', className)}
        style={{ width: width ? width : 200 }}
        onClick={onClick}
        {...otherProps}
      >
        <div
          className={classNames('rfd-ui-select-button', {
            'rfd-ui-icon-right': iconRight
          })}
        >
          {icon && !iconRight && <i className={'icon-aytmfd-' + icon} />}
          <span className="rfd-ui-select-button-text" dangerouslySetInnerHTML={{ __html: placeholder }} />
          {icon && iconRight && <i className={'icon-aytmfd-' + icon} />}
          {withArrow && <span className="rfd-ui-select-button-arrow" />}
        </div>
      </div>
    )
  }
}
